// Function to generate section data
const getSectionData = (id, section, selector) => ({ id, section, selector });

// Check cart drawer and set sections to render
const cartDrawer = document.querySelector('cart-drawer');
let sectionsToRender = [];

if (cartDrawer) {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter"),
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  } else {
    sectionsToRender = [
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  }
} else {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData('#cart-counter', 'cart-counter', '#shopify-section-cart-counter')
    ];
  } else {
    sectionsToRender = [];
  }
}

// Function to protect elements from being replaced during cart update
function protectElementsDuringUpdate(container, newHTML) {
  // Create a temporary div to parse the new HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = newHTML;
  
  // Get elements to protect (keep existing ones)
  const existingRecommendations = container.querySelector('.cart-recommendations');
  const existingBogoBar = container.querySelector('.cart-drawer__bogo-bar');
  
  // Remove these elements from the new HTML so they don't get replaced
  const newRecommendations = tempDiv.querySelector('.cart-recommendations');
  const newBogoBar = tempDiv.querySelector('.cart-drawer__bogo-bar');
  
  // ALWAYS remove recommendations and BOGO from tempDiv before innerHTML update
  // to prevent duplication - we'll manually insert them after
  if (newRecommendations) {
    newRecommendations.remove();
  }
  
  if (newBogoBar) {
    newBogoBar.remove();
  }
  
  // Update the container with the modified HTML
  container.innerHTML = tempDiv.innerHTML;
  
  // Re-insert the protected elements in their correct positions
  const cartMain = container.querySelector('.cart-drawer__main');
  const cartBottom = container.querySelector('.cart-drawer__bottom');
  
  // Handle BOGO bar: prefer existing, fall back to new
  if (existingBogoBar && cartBottom) {
    cartBottom.insertAdjacentElement('beforebegin', existingBogoBar);
  } else if (newBogoBar && cartBottom) {
    cartBottom.insertAdjacentElement('beforebegin', newBogoBar);
  }
  
  // Handle recommendations: prefer existing, fall back to new
  if (existingRecommendations && cartMain) {
    cartMain.appendChild(existingRecommendations);
  } else if (newRecommendations && cartMain) {
    cartMain.appendChild(newRecommendations);
    
    // Initialize swiper directly for newly inserted recommendations
    setTimeout(() => {
      initializeCartRecommendationsSwiper();
    }, 200);
  }
}

// Function to initialize cart recommendations swiper
function initializeCartRecommendationsSwiper() {
  const swiperElement = document.querySelector('.cart-recommendations__swiper');
  if (!swiperElement) {
    console.log('Cart recommendations swiper element not found');
    return;
  }

  // Check if Swiper is loaded
  if (typeof Swiper === 'undefined') {
    if (window.whenSwiperReady) {
      window.whenSwiperReady(initializeCartRecommendationsSwiper);
    } else {
      setTimeout(initializeCartRecommendationsSwiper, 100);
    }
    return;
  }

  // Destroy existing swiper if it exists
  if (window.cartRecommendationsSwiper && !window.cartRecommendationsSwiper.destroyed) {
    console.log('Destroying existing recommendations swiper');
    window.cartRecommendationsSwiper.destroy(true, true);
  }

  // Create new swiper instance
  try {
    console.log('Initializing cart recommendations swiper');
    window.cartRecommendationsSwiper = new Swiper('.cart-recommendations__swiper', {
      slidesPerView: 3,
      spaceBetween: 1,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next-custom',
        prevEl: '.swiper-button-prev-custom',
      },
      breakpoints: {
        320: {
          slidesPerView: 3,
          spaceBetween: 1
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 1
        }
      },
      on: {
        init: function() {
          console.log('Swiper initialized successfully');
          // Ensure buttons are clickable after init
          const nextBtn = document.querySelector('.swiper-button-next-custom');
          const prevBtn = document.querySelector('.swiper-button-prev-custom');
          if (nextBtn) nextBtn.style.pointerEvents = 'auto';
          if (prevBtn) prevBtn.style.pointerEvents = 'auto';
        }
      }
    });
  } catch (e) {
    console.error('Error initializing recommendations swiper:', e);
  }
}

// Make function globally available
window.initializeCartRecommendations = initializeCartRecommendationsSwiper;

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      updateFreeShipping();
      
      // Reinitialize cart recommendations after removal
      setTimeout(() => {
        if (typeof window.forceReinitializeCartRecommendations === 'function') {
          window.forceReinitializeCartRecommendations();
        } else if (typeof window.initializeCartRecommendations === 'function') {
          window.initializeCartRecommendations();
        }
      }, 300);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.freeShipping = document.querySelectorAll('shipping-bar');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change', this.debouncedOnChange.bind(this)
    );

    updateFreeShipping();
  }

  calculateTotalItemCount(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender()?.forEach(section => {
          const elementToReplace = document.querySelector(section.selector) || document.querySelector(section.id);

          if (elementToReplace) {
            if (!parsedState.errors) {
              const newHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
              
              // Use protection method to preserve recommendations and BOGO bar
              protectElementsDuringUpdate(elementToReplace, newHTML);
            }
          } else {
            console.error(`Element with selector ${section.selector} not found`);
          }
        });
        
        if (!parsedState.errors) {
          this.totalItemCount = this.calculateTotalItemCount(parsedState.items);
        }
        this.updateLiveRegions(line, parsedState.item_count, parsedState.errors);

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateCartCounters();
        updateFreeShipping();
        
        // Update BOGO bar (will fetch cart and filter excluded products)
        if (typeof window.updateBogoProgressBar === 'function') {
          window.updateBogoProgressBar();
        }
        
        // Don't update compare price here - it's already in the server response
        
        // Toggle empty_drawer class based on cart state
        const cartDrawerElement = document.querySelector('.cart-drawer');
        const cartDrawerInner = document.querySelector('.cart-drawer__inner');
        if (parsedState.item_count === 0) {
          cartDrawerElement?.classList.add('empty_drawer');
          cartDrawerInner?.classList.add('empty_drawer');
        } else {
          cartDrawerElement?.classList.remove('empty_drawer');
          cartDrawerInner?.classList.remove('empty_drawer');
        }
        
        // Dispatch custom event for cart update
        document.dispatchEvent(new CustomEvent('cart-updated', {
          detail: { line, quantity, name }
        }));
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount, parsedError) {
    if (parsedError) {
      document
        .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
        .forEach(error => {
          error.innerHTML = parsedError;
        });
    }

    this.currentItemCount = itemCount;
  }
}
customElements.define('cart-items', CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", event => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.setCartLink();
    this.parentElement.addEventListener("shopify:section:select", () => this.open());
    this.parentElement.addEventListener("shopify:section:deselect", () => this.close());
  }

  setCartLink() {
    const cartLink = document.querySelector("[data-cart-link]");
    if (cartLink) {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", event => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", event => {
        if (event.code.toUpperCase() !== "SPACE") return;
        event.preventDefault();
        this.open(cartLink);
      });
    } else {
      console.error("Cart link not found");
    }
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add("is-visible");
    document.querySelector('body').style.overflow = 'hidden';
    this.addEventListener("transitionend", () => { this.focusOnCartDrawer(); }, { once: true });

    setTimeout(() => {
      document.addEventListener("click", this.handleOutsideClick);
    }, 100);

    const productReccomendations = document.querySelector(".product-recommendations");
    if (productReccomendations) {
      if (productReccomendations.classList.contains("hidden")) {
        document.querySelector(".cart-drawer-items").classList.add("cart-drawer-items__full");
      } else {
        document.querySelector(".cart-drawer-items").classList.remove("cart-drawer-items__full");
      }
    }
    
    // Initialize cart swipers when drawer opens (if not already initialized)
    setTimeout(() => {
      if (typeof window.initializeCartRecommendations === 'function') {
        window.initializeCartRecommendations();
      }
      // Update BOGO bar when drawer opens
      if (typeof window.updateBogoProgressBar === 'function') {
        window.updateBogoProgressBar();
      }
      // Compare price is already rendered by the server, no need to update
    }, 100);
  }

  close() {
    this.classList.remove("is-visible");
    document.querySelector('body').style.overflow = 'auto';
    removeTrapFocus(this.activeElement);

    document.removeEventListener("click", this.handleOutsideClick);

    const isHeaderMenuOpen = header.classList.contains("menu-open");

    if (isHeaderMenuOpen) {
      return;
    }

    // if we are on the cart page, resubmit form
    if (window.location.pathname === "/cart") {
      const cartDrawerForm = document.getElementById("CartDrawer-FormSummary");
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  handleOutsideClick = event => {
    const cartDrawerInner = this.querySelector(".cart-drawer__inner");
    if (cartDrawerInner && !cartDrawerInner.contains(event.target)) {
      this.close();
    }
  };

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector("[data-drawer-close]");
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement) return;
      
      const newHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
      
      // Use protection method to preserve recommendations and BOGO bar
      protectElementsDuringUpdate(sectionElement, newHTML);

      updateCartCounters();
    });
    
    // Update BOGO bar (will fetch cart and filter excluded products)
    if (typeof window.updateBogoProgressBar === 'function') {
      window.updateBogoProgressBar();
    }
    
    // Don't update compare price here - it's already in the server response
    
    // Toggle empty_drawer class based on cart state
    const cartDrawerElement = document.querySelector('.cart-drawer');
    const cartDrawerInner = document.querySelector('.cart-drawer__inner');
    if (response.item_count === 0) {
      cartDrawerElement?.classList.add('empty_drawer');
      cartDrawerInner?.classList.add('empty_drawer');
    } else {
      cartDrawerElement?.classList.remove('empty_drawer');
      cartDrawerInner?.classList.remove('empty_drawer');
    }
    
    // Dispatch custom event for cart drawer refresh
    document.dispatchEvent(new CustomEvent('cart-drawer-refreshed'));
    
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);

// No longer needed - recommendations stay in DOM and swiper keeps working

// Function to update BOGO progress bar: snippets/cart-drawer.liquid decides what the bar says (one count, language
// and market included), so every update takes the freshly rendered bar. Only the latest request may win.
let bogoBarRequest = 0;
function updateBogoProgressBar() {
  if (!document.querySelector('.cart-drawer__bogo-bar')) return;
  const request = ++bogoBarRequest;

  // No Accept: application/json here: on /products and /collections that returns the product or collection JSON instead
  fetch(`${window.location.pathname}?sections=cart-drawer`)
    .then(response => response.json())
    .then(sections => {
      if (request !== bogoBarRequest) return;
      const fresh = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html').querySelector('.cart-drawer__bogo-bar');
      const current = document.querySelector('.cart-drawer__bogo-bar');
      if (fresh && current && current.outerHTML !== fresh.outerHTML) current.replaceWith(fresh);
    })
    .catch(error => console.error('Error updating BOGO bar:', error));
}

// Function to update compare price total in cart drawer
async function updateCartComparePrice() {
  // Wait a bit to ensure DOM is updated
  await new Promise(resolve => setTimeout(resolve, 50));
  
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    let totalComparePrice = 0;
    let hasComparePrice = false;
    
    // Calculate total compare price
    cart.items.forEach(item => {
      if (item.product_id === 16202253238606) return; // Spooky Gift: not part of the compare total
      if (item.properties && item.properties._sava_gift) return; // SAVA free gifts (BF 2026): idem
      if (item.compare_at_price && item.compare_at_price > item.price) {
        totalComparePrice += item.compare_at_price * item.quantity;
        hasComparePrice = true;
      } else {
        totalComparePrice += item.price * item.quantity;
      }
    });
    
    // Get the compare price element (inline with subtotal)
    const comparePriceElement = document.querySelector('.cart-drawer__compare-price');
    
    if (comparePriceElement) {
      if (hasComparePrice) {
        // Update the compare price
        comparePriceElement.dataset.cartComparePrice = totalComparePrice;
        // Format the price using Shopify's money format
        const moneyFormat = window.theme?.settings?.money_format || '€{{amount_with_comma_separator}}';
        const formatted = formatMoney(totalComparePrice, moneyFormat);
        comparePriceElement.textContent = formatted;
        // Show the compare price with inline-block
        comparePriceElement.style.setProperty('display', 'inline-block', 'important');
      } else {
        // Hide the compare price if no discounts
        comparePriceElement.style.setProperty('display', 'none', 'important');
      }
    }
  } catch (error) {
    console.error('Error updating compare price:', error);
  }
}

// Helper function to format money (simplified version)
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';
  
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';
    
    if (isNaN(number) || number == null) {
      return 0;
    }
    
    number = (number / 100.0).toFixed(precision);
    
    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';
    
    return dollarsAmount + centsAmount;
  }
  
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  
  return formatString.replace(placeholderRegex, value);
}

// Make functions globally available
window.updateBogoProgressBar = updateBogoProgressBar;
window.updateCartComparePrice = updateCartComparePrice;
